import styled from 'styled-components';
import Wrapper from 'gatsby-theme-core/src/components/form-elements/checkbox/wrapper';
import Icon from './icon';

// + 2px for border
export default styled(Wrapper)`
  height: calc(1.25rem + 2px);
  width: calc(1.25rem + 2px);

  &:focus-within {
    ${Icon} {
      box-shadow: 0px 0px 3px blue;
    }
  }
`;
